import { BrowserRouter as Router } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { AppRoutes } from './routes';
import { ToastContainer } from './components/ui/ToastContainer';
import { LoadingProvider } from './context/LoadingContext';
import { useAuthErrorHandler } from './hooks/useAuthErrorHandler';
import { DataPreloader } from './components/data/DataPreloader';
import { CompanyProvider } from './context/CompanyContext';

function AppContent() {
  // Gestionnaire global des erreurs d'authentification
  useAuthErrorHandler();
  
  return (
    <Layout>
      <DataPreloader />
      <AppRoutes />
      <ToastContainer />
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <LoadingProvider>
        <CompanyProvider>
          <AppContent />
        </CompanyProvider>
      </LoadingProvider>
    </Router>
  );
}

export default App;